import axios from "axios"

const cesionesService = {
  IsEmpresaActivaHasCesiones(queryParam = "") {
    return axios.get(`/Cesion/any/${queryParam}`)
  },
}

export default cesionesService
